import { render, staticRenderFns } from "./HeaderCampaignCoupons.vue?vue&type=template&id=8bb73bbe"
import script from "./HeaderCampaignCoupons.vue?vue&type=script&lang=js"
export * from "./HeaderCampaignCoupons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
